module.exports = __webpack_public_path__ + "img/driveboo_logo.f55b52a.png";